/* Remate de pantallas-alumno (R3): CIFRAS DE ANCHO FIJO PARA LOS NUMEROS QUE CAMBIAN MIENTRAS SE MIRAN.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   La letra de la casa no trae cifras de ancho fijo (el "1" es mas angosto que el "0"), asi que un numero
   que cambia cambia de ancho y empuja lo que tiene al lado: la medicion lo vio en la pildora del reloj del
   examen (unos 4 px, y como va al centro de la cabecera, se movia). La tecnica es la del contador de
   Adaptive (`Cifra` de `AdaptiveStudy.js`, una caja de N x (1ch + 1px) por numero de N cifras): aqui
   cada cifra va en su propia caja de 1ch + 1px, centrada, y lo demas (dos puntos, raya, palabras) se
   queda como texto. Sirve para un texto ya traducido ("{known} / {total} known"). El texto no cambia:
   `textContent` es el mismo. */
import React from 'react';

export const ANCHO_DE_CIFRA = 'calc(1ch + 1px)';

export default function CifrasFijas({ texto }) {
  if (texto === null || texto === undefined) return null;
  const partes = String(texto).split(/(\d)/).filter((p) => p !== '');
  return partes.map((p, i) => (/^\d$/.test(p)
    ? <span key={i} data-parte="cifra-fija" className="inline-block text-center" style={{ width: ANCHO_DE_CIFRA }}>{p}</span>
    : <React.Fragment key={i}>{p}</React.Fragment>));
}
